import React from "react";
import { StyleSheet, View } from "react-native";
import colors from "../config/colors";
import { normalize } from "../util/normalize";
import AppText from "./AppText";

function Header({ title }) {
  return (
    <View style={styles.container}>
      <View>
        <AppText
          style={styles.headerText}
          color="transparent"
          textColor="primary"
          onPress={() => window.open("https://bluecardvisa.com", "_self")}
        >
          {title}
        </AppText>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  headerText: {
    fontWeight: "bold",
    fontSize: normalize(30),
    letterSpacing: 1,
    alignSelf: "center",
    cursor: "pointer",
  },
});

export default Header;
